import React from 'react'
import PriceText from '../ui/PriceText'
import { useTranslation } from 'react-i18next'
import { Loader } from 'lucide-react';

type Props ={
    availableBalance?: number;
    totalCanceled?: number;
    totalRefunded?: number;
    totalEarning?:number,
    loading:boolean
}

function FirstSectionHeroLand({availableBalance,totalCanceled,totalRefunded,totalEarning,loading}:Props) {
    const {t} = useTranslation();
  return (
    <div>
        <div className=' shadow-custom-light bg-[#FFFFFF] rounded-2xl p-6 mb-4'>
            <h4 className=' text-Black font-medium text-[12px] mb-1'>{t('availableBalance')}</h4>
            <div className='flex gap-2 items-center'>
                <img src="/images/PaymentLogo.png" alt="" className=' w-6 h-6'/>
                <img src="/Vector2.png" alt="" className=' '/>
                {loading? <Loader className=' text-Black'/> : <PriceText value={ availableBalance||0}/>}
            </div>
        </div>
        <div className='grid xl:grid-cols-3 gap-5'>
        <div className=' shadow-custom-light bg-[#FFFFFF] rounded-2xl p-6 flex justify-between pe-0'>
            <div>
                <h4 className=' text-Black font-medium text-[12px] mb-1'>{t('totalEarning')}</h4>
                <div className='flex gap-1 items-center'>
                    <img src="/Vector.png" alt=""/>
                    <span className=' text-primaryButton text-[24px] font-black'>{loading? <Loader/> :totalEarning}</span>
                </div>
            </div>
            <img src="/images/Cancelled.png" alt="" />
        </div>
        <div className=' shadow-custom-light bg-[#FFFFFF] rounded-2xl p-6 flex justify-between pe-0'>
            <div>
                <h4 className=' text-Black font-medium text-[12px] mb-1'>{t('totalCancelled')}</h4>
                <div className='flex gap-1 items-center'>
                    <img src="/Vector2.png" alt=""/>
                    <span className=' text-Black text-[24px] font-black'>{loading ? <Loader/> : totalCanceled}</span>
                </div>
            </div>
            <img src="/images/Cancelled.png" alt="" />
        </div>
         <div className=' shadow-custom-light bg-[#FFFFFF] rounded-2xl p-6 flex justify-between pe-0'>
            <div>
                <h4 className=' text-Black font-medium text-[12px] mb-1'>{t('totalRefunded')}</h4>
                <div className='flex gap-1 items-center'>
                    <img src="/Vector3.png" alt="" className='w-[13.33px] h-[14.93px]'/>
                    <span className=' text-Red text-[24px] font-black'>{loading?<Loader/> : totalRefunded}</span>
                </div>
            </div>
            <img src="/images/Refunded.png" alt="" />
        </div>
    </div>
    </div>
  )
}

export default FirstSectionHeroLand